const setCatType5 = (payload) => {
  return {
    type: "catType5",
    payload,
  };
};

export default setCatType5;
